import { IFormItem } from '@components/Form/FormItem/FormItem';
import { Validators } from '@components/Form/FormItem/FormItemValidation';

import { dictToOptions } from '@/utils/utils';

export const createTablePartModalConfig = (dictionaries: any) =>
  [
    {
      label: 'Показания к применению',
      key: 'researchTypeId',
      type: 'autocomplete',
      validation: [Validators.required()],
      payload: {
        options: dictToOptions(dictionaries?.RESEARCH_TYPE),
      },
    },
    {
      type: 'group',
      key: 'dosage',
      label: 'Дозировка',
      separator: ['–', '/'],
      items: [
        {
          key: 'dosageFrom',
          type: 'text',
          placeholder: 'От (мл)',
          validation: [Validators.required()],
        },
        {
          key: 'dosageTo',
          type: 'text',
          placeholder: 'До (мл)',
        },
        {
          key: 'dosageWeight',
          type: 'text',
          placeholder: 'На (кг)',
        },
      ],
    },
    {
      label: 'Тип применения',
      key: 'applicationTypeId',
      type: 'select',
      payload: {
        options: dictionaries?.APPLICATION_TYPE,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
    },
    {
      label: 'Вид животного',
      key: 'animalSpeciesId',
      type: 'select',
      payload: {
        options: dictionaries?.ANIMAL_SPECIES,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
    },
    {
      type: 'group',
      key: 'age',
      label: 'Возраст',
      separator: ['–'],
      items: [
        {
          key: 'ageFrom',
          type: 'text',
          placeholder: 'От (дней)',
        },
        {
          key: 'ageTo',
          type: 'text',
          placeholder: 'До (дней)',
        },
      ],
    },
    {
      label: 'Способ введения',
      key: 'administrationRouteIds',
      type: 'select',
      validation: [Validators.required()],
      payload: {
        mode: 'multiple',
        options: dictionaries?.ADMINISTRATION_ROUTE,
        fieldNames: {
          label: 'name',
          value: 'id',
        },
      },
    },
    {
      label: 'Примечание',
      key: 'note',
      type: 'text',
    },
  ] as IFormItem[];
